module.exports = __webpack_public_path__ + "assets/img/cricket-denmark.80fbb300.jpg";